import React, { useState,useRef } from "react";
import { useNavigate } from "react-router-dom";
import "./teamAssignmentCardStatsView.scss";
import { getFieldStyle } from "../../themes";

export default function TeamAssignmentCardStatsView({
    data,
    type,
    analyticsAction,
    jdStatus,
}) {

    const navigate = useNavigate();
    const inputRef = useRef(null);
  

    return (
    <div className="teamAssignmentCardStatsView-wrapper">
      <div className="teamAssignmentCardStatsView-title-wrapper">
        <div className="teamAssignmentCardStatsView-title-heading">{type}</div>
        <div className="teamAssignmentCardStatsView-title-action">
          {analyticsAction}
        </div>
      </div>
      {[...data]?.map((entry) => {
        return (
          <div className="teamAssignmentCardStatsView-Values-wrapper">
            <div className="teamAssignmentCard-Stats-subheading-wrapper">
              {entry[0]}
            </div>
            <div className="teamAssignmentCard-Stats-subheading-value">
              {entry[1] != 0 ? entry[1] : "-"}
            </div>
          </div>
        );
      })}
    </div>
    );
}
